export type RslDonutChartOptionsProps = {
  formatter: (value: number | null | undefined) => string;
  overallValue?: number | null;
  data: {
    name: string;
    value: number | null | undefined;
    color: string;
  }[];
};

export const rslDonutChartOptions = (
  props: RslDonutChartOptionsProps
): Highcharts.Options => {
  const total =
    props.overallValue ??
    props.data.reduce((sum, item) => sum + (item.value ?? 0), 0);

  return {
    credits: {
      enabled: false,
    },
    exporting: {
      enabled: false,
    },
    chart: {
      margin: [60, 80, 60, 80],
    },
    title: {
      text: `<div style="text-align: center; font-size: 16px; font-weight: bold;">${props.formatter(total)}</div><div style="text-align: center; font-size: 11px; color: #666; margin-top: 3px;">Overall</div>`,
      align: 'center',
      verticalAlign: 'middle',
      useHTML: true,
      y: 10,
    },
    tooltip: {
      pointFormatter() {
        return props.formatter(this.y);
      },
    },
    series: [
      {
        type: 'pie',
        size: '80%',
        innerSize: '60%',
        dataLabels: {
          enabled: true,
          distance: 25,
          formatter() {
            return `${this.name}<br />${props.formatter(this.y)}`;
          },
          style: {
            fontWeight: 'normal',
            textOverflow: 'none',
          },
          crop: false,
          overflow: 'allow',
          connectorShape: 'straight',
        },
        data: props.data.map(dataItem => ({
          name: dataItem.name,
          y: dataItem.value ?? 0,
          color: dataItem.color,
        })),
      },
    ],
  };
};
